import { useEffect, useState } from 'react';

/**
 * Trả về giá trị sau khi nó đứng yên `delay` mili-giây.
 *
 * Dùng cho ô tìm kiếm sau khi chuyển việc lọc xuống máy chủ (spec SC-13 §2.3):
 * gõ "rooland" mà gọi API theo từng phím là bảy lượt gọi cho một lần tìm, và các
 * phản hồi có thể về không đúng thứ tự gõ.
 *
 * Yêu cầu của spec là "giữ nguyên trải nghiệm hiện tại: gõ vào ô tìm là lọc dần" —
 * 300 ms đủ ngắn để vẫn thấy như lọc tức thì, đủ dài để một từ chỉ tốn một lượt gọi.
 */
export function useDebounced<T>(value: T, delay = 300): T {
  const [cham, setCham] = useState(value);

  useEffect(() => {
    const t = setTimeout(() => setCham(value), delay);
    // Dọn bộ đếm giờ cũ mỗi lần `value` đổi — không có dòng này thì mỗi phím gõ
    // để lại một bộ đếm, và tất cả đều nổ.
    return () => clearTimeout(t);
  }, [value, delay]);

  return cham;
}
